<template>
  <div id="app">
		<h-header :hcurID="hcurID"></h-header>
		<router-view></router-view>
		<foot></foot>
  </div>
</template>

<script>

export default {
  name: 'app',
  // components: {
		// hHeader
  // },
	data(){
		return{
			hcurID:'',
			setting:[],
			
		}
	},
	methods:{

	},
	created() {
		if(this.$route.path=='/'){
			this.hcurID = 2;
		}else if(JSON.stringify(this.$route.params)=='{}'){
			this.hcurID = this.$route.query.category_id
		}else{
			this.hcurID = this.$route.params.id
		}
	},
	watch :{
		'$route' (to, from) {
				// 对路由变化作出响应...
				if(this.$route.path=='/'){
					this.hcurID = 2;
				}else if(JSON.stringify(this.$route.params)=='{}'){
					this.hcurID = this.$route.query.category_id
				}else{
					this.hcurID = this.$route.params.id
				}
		}
	},
  mounted(){
	
  }
}
</script>

<style>
	

</style>
